import * as React from 'react'
import { FC } from 'react'
import { getStyles } from './styling'
import { LocationLink } from '@user/components/Location'
import { OverflowDetector } from '@sales-center/components'
import { useData } from './useData'
import { TruncatedText } from '@user/components/Location/SmallLocationCard/TruncatedText'
import { BillTo } from '@user/store/entityLocations'
import { useToggleBoolean } from '@user/utils/useToggleBoolean'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import { useTheme } from '@mui/material/styles'

export interface Props {
  headerContent?: React.ReactNode
  location: BillTo
  splitAddressIndex?: number
}

export const BillToSelectCardContents: FC<Props> = (props: Props) => {
  const { headerContent, location } = props

  const [open, toggleOpen] = useToggleBoolean()
  const { properties } = useData(props)
  const hasMoreFields = properties.length > 2
  const verb = open ? 'Less' : 'More'
  const theme = useTheme()
  const styles = getStyles(theme)
  return (
    <Grid sx={styles.card} container direction="column">
      <Grid container item direction="row" justifyContent="space-between">
        <Grid sx={styles.variantLabel} item mb={0.6}>
          Bill-to
        </Grid>
        <Grid>{headerContent}</Grid>
      </Grid>
      <Grid item>
        <LocationLink
          externalLocationCode={location.number}
          externalLocationId={location.id}
          billingLocation={true}
        />
      </Grid>
      <Grid sx={styles.item} item>
        <OverflowDetector open={open} closedHeight={42}>
          {properties.map((p, i) => (
            <TruncatedText key={i} truncated={!open}>
              <Typography color={theme.palette.text.primary}>{p}</Typography>
            </TruncatedText>
          ))}
        </OverflowDetector>

        {hasMoreFields && (
          <Typography sx={styles.expandLink} onClick={toggleOpen} mt={0.6}>
            View {verb} Information
          </Typography>
        )}
      </Grid>
    </Grid>
  )
}
BillToSelectCardContents.displayName = 'BillToSelectCardContents'
